import { useContext } from "react";
import MonitoringPoliciesTable from "../components/MonitoringPoliciesTable";
import PoliciesTable from "../components/PoliciesTable";
import { ClientContext } from "../App";
import { get } from "lodash";

const Policies = () => {
  const { clientConfig } = useContext(ClientContext);
  return (
    <div className="flex flex-col flex-1 h-full px-12 gap-y-8">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Policies</h1>
      </div>
      {get(clientConfig, "config.ignitionConfig.scopes.monitoring") ? (
        <MonitoringPoliciesTable />
      ) : (
        <PoliciesTable />
      )}
    </div>
  );
};

export default Policies;
